module.exports = __webpack_public_path__ + "img/om1.39e624d1.jpg";